var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowdown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 10 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.85114 16.2004L11.4496 21.7989C11.5837 21.933 11.7514 22 11.9525 22C12.1536 22 12.3213 21.933 12.4554 21.7989L18.0203 16.2004C18.2438 16.0216 18.3332 15.7869 18.2885 15.4964C18.2215 15.2058 18.0427 15.027 17.7521 14.96C17.4616 14.8929 17.2269 14.9711 17.0481 15.1946L12.6565 19.6198L12.6565 2.704C12.6565 2.50286 12.5895 2.33524 12.4554 2.20114C12.3213 2.06705 12.1536 2 11.9525 2C11.7514 2 11.5837 2.06705 11.4496 2.20114C11.3155 2.33524 11.2485 2.50286 11.2485 2.704L11.2485 19.6198L6.85686 15.1946C6.72277 15.0605 6.55515 14.9935 6.354 14.9935C6.15286 14.9935 5.98524 15.0605 5.85114 15.1946C5.71705 15.3287 5.65 15.4964 5.65 15.6975C5.65 15.8986 5.71705 16.0663 5.85114 16.2004Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowdown);
export default __webpack_public_path__ + "static/media/Arrow down.2301cc3269295d99633bbab185b39d92.svg";
export { ForwardRef as ReactComponent };